module.exports = __webpack_public_path__ + "media/images/email-63eb04d357a5ebfe02e3155a309bae17.svg";